import { HDivider } from "./PropertySummary";
import { Mail } from "@landvoice/icons";
import Socials from "./Socials"
import { OwnerContactInfo as OwnerContactInfoType } from "src/types/listing";

const OwnerContactInfo = (props: OwnerContactInfoType) => {
  const { fullName, email, address, socials } = props;
  const { streetAddress, city, state, postalCode, unit } = address || {};

  // Build street address with unit if present
  const displayStreetAddress = unit ? `${streetAddress} ${unit}` : streetAddress;

  const hasSocials = !!Object.values(socials || {}).length;
  return (
    <div className="lg:flex   flex-col h-full lg:py-0 py-4  md:w-[216px]">
      <p className=" text-[14px] text-gray-secondary lg:leading-6 font-semibold">
        Owner's Information
      </p>
      {fullName && fullName !== " " ? (
        <p className=" text-[16px] text-gray-primary lg:leading-6 lg:mb-3 mb-1">
          {fullName || "--"}
        </p>
      ) : (
        <p className=" text-[16px] text-gray-primary leading-6 mb-3 italic">
          Owner's Name not found
        </p>
      )}

      {streetAddress ? (
        <p className=" text-[14px] text-gray-primary leading-[14px] mb-[13px]">
          {streetAddress
            ? `${displayStreetAddress || "--"}, ${city || "--"}, ${state || "--"} ${
                postalCode || "--"
              }`
            : "--"}
        </p>
      ) : (
        <p className=" text-[14px] text-gray-primary leading-[14px] mb-[13px] italic">
          No address found
        </p>
      )}

      <div className="flex gap-2 max-h-4 mb-2">
        <Mail />
        {email ? (
          <p className=" leading-[14px] text-[14px] text-gray-primary underline cursor-pointer text-ellipsis overflow-hidden">
            <a href={`mailto:${email}`}>{email}</a>
          </p>
        ) : (
          <p className=" leading-[14px] text-[14px] text-gray-primary italic">
            No email found
          </p>
        )}
      </div>
      {hasSocials && (
        <>
          <HDivider />
          <div className="h-4 mt-2 flex gap-[14px]">
            <Socials {...socials} />
          </div>
        </>
      )}
    </div>
  );
};

export default OwnerContactInfo;
